import {Component, computed, input, output, ChangeDetectionStrategy} from "@angular/core"
import {NgClass} from "@angular/common"
import {ThumbnailLayout} from "@common/models/enums/thumbnail-layout"
import {assertNever} from "@cm/utils"
import {Settings} from "@common/models/settings/settings"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-thumbnail",
    imports: [NgClass],
    templateUrl: "./thumbnail.component.html",
    styleUrl: "./thumbnail.component.scss",
})
export class ThumbnailComponent {
    readonly $url = input<string | null>(null, {alias: "url"})
    readonly $layout = input(ThumbnailLayout.Contain, {alias: "layout"})
    readonly load = output<Event>()

    fallbackUrl = Settings.IMAGE_NOT_AVAILABLE_SMALL_URL

    protected readonly $layoutClass = computed(() => {
        const layout = this.$layout()
        switch (layout) {
            case ThumbnailLayout.Contain:
                return "cm-thumbnail-contain"
            case ThumbnailLayout.Cover:
                return "cm-thumbnail-cover"
            default:
                assertNever(layout)
        }
    })
}
